import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { ChanelConfig } from '../../../../../configs/GlobalConfig';
import MessageHub from '../../../../../core/signalr/SignalrMessageHub';
import TabFilter from '../../../../common/tab-filter';
import { getDefaultIfEmpty } from '../../../../helpers/Common';
import {
  cancelfetchDataPressing,
  fetchDataPressing,
  subscribeRealtimeTickPressing,
  changeFilterLineOne,
  changeFilterLineTwo,
  changeFilterLineThree,
  REDUCER_NAME,
  loadMorePressing,
} from '../reducer';
import Const from './Const';
import Table from './Table';
import TAConst from '../Const';
import { formatTextFloat } from '../../../../helpers/Text';

const defaultSortState = { averageMatchVolume2Week: 'desc' };

class Pressing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pressingOrder: Const.filterOrder[this.props.filter.filterLineTwo].text,
      sortState: defaultSortState,
      page: 1,
    };
    this.tableRef = React.createRef();
  }

  componentDidMount() {
    this.fetchData();
    MessageHub.subscribe(ChanelConfig.TickChanel, this.dispatchDataRealtime);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { filter, currentSearch, watchListId } = this.props;
    if (
      filter !== nextProps.filter ||
      currentSearch !== nextProps.currentSearch ||
      watchListId !== nextProps.watchListId
    ) {
      this.setState({
        page: 1,
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { sortState } = this.state;
    const { filter, currentSearch, watchListId } = this.props;
    const isChangeSortState = sortState !== prevState.sortState;
    if (
      filter !== prevProps.filter ||
      currentSearch !== prevProps.currentSearch ||
      watchListId !== prevProps.watchListId ||
      isChangeSortState
    ) {
      this.fetchData();
      setTimeout(() => {
        if (this.tableRef.current) {
          this.tableRef.current.scrollToTop();
        }
      }, 0);
    }
  }

  componentWillUnmount() {
    const { cancelfetchDataPressing } = this.props;
    cancelfetchDataPressing();
    MessageHub.unsubscribe(ChanelConfig.TickChanel, this.dispatchDataRealtime);
  }

  fetchData = () => {
    const { sortState } = this.state;
    const { fetchDataPressing, filter } = this.props;
    fetchDataPressing(
      Const.filterAvgVolume[filter.filterLineOne],
      Const.filterOrder[filter.filterLineTwo].text,
      Const.filterProportion[filter.filterLineThree],
      sortState,
    );
  };

  onLoadMore = page => {
    const { sortState } = this.state;
    const { loadMorePressing, filter } = this.props;
    this.setState({
      page,
    });
    loadMorePressing({
      page,
      sortState,
      pageSize: TAConst.itemPerPage,
      currentAvgVolume: Const.filterAvgVolume[filter.filterLineOne],
      orderType: Const.filterOrder[filter.filterLineTwo].text,
      proportion: Const.filterProportion[filter.filterLineThree],
    });
  };

  dispatchDataRealtime = data => {
    const { subscribeRealtimeTickPressing } = this.props;
    subscribeRealtimeTickPressing(data);
  };

  changeAvgVolume = currentAvgVolume => {
    const { changeFilterLineOne, filter } = this.props;
    if (filter.filterLineOne !== currentAvgVolume) {
      changeFilterLineOne(currentAvgVolume);
    }
  };

  changeOrder = currentOrder => {
    const { changeFilterLineTwo, filter } = this.props;
    if (filter.filterLineTwo !== currentOrder) {
      changeFilterLineTwo(currentOrder);
    }
    this.setState({ pressingOrder: Const.filterOrder[currentOrder].text });
  };

  changeProportion = currentProportion => {
    const { changeFilterLineThree, filter } = this.props;
    if (filter.filterLineThree !== currentProportion) {
      changeFilterLineThree(currentProportion);
    }
  };

  onSort = sortState => {
    this.setState({
      sortState: getDefaultIfEmpty(sortState, defaultSortState),
    });
  };

  render() {
    const { page } = this.state;
    const { filter } = this.props;
    return (
      <div className="d-flex flex-column flex-fill">
        <div>
          <div className="list-filter top-nav">
            <span className="left-label-2 left-label">
              {I18n.t('tasignals.pressingContent.line_2')}
            </span>
            <TabFilter
              currentTab={filter.filterLineOne}
              listTab="tasignals.filterAvgVolume"
              changeTab={this.changeAvgVolume}
            />
          </div>
          <div className="list-filter top-nav">
            <span className="left-label-2 left-label">
              {I18n.t('tasignals.pressingContent.line_3')}
            </span>
            <TabFilter
              currentTab={filter.filterLineTwo}
              listTab="tasignals.filterPressingOrderType"
              changeTab={this.changeOrder}
            />
          </div>
          <div className="list-filter top-nav">
            <span className="left-label-2 left-label">
              {I18n.t('tasignals.pressingContent.line_4')}
            </span>
            <TabFilter
              currentTab={filter.filterLineThree}
              listTab="tasignals.filterProportion"
              changeTab={this.changeProportion}
            />
          </div>
          <div className="list-text-display">
            <span className="light-text">
              {I18n.t('tasignals.pressingContent.line_5.part_1')}
            </span>
            <span className="bold-text">
              {I18n.t('tasignals.pressingContent.line_5.part_2')}
              {formatTextFloat(
                Number(Const.filterAvgVolume[filter.filterLineOne]),
                0,
              )}
            </span>
            <span className="light-text">
              {' '}
              {I18n.t('tasignals.pressingContent.line_5.part_3')}
            </span>
            <span className="bold-text">
              {I18n.t(Const.filterOrder[filter.filterLineTwo].quote)}
              {Const.filterProportion[filter.filterLineThree] * 100} %{' '}
            </span>
          </div>
        </div>
        <div className="mt-10 d-flex flex-fill">
          <Table
            scrollRef={this.tableRef}
            onLoadMore={this.onLoadMore}
            onSort={this.onSort}
            pressingOrder={this.state.pressingOrder}
            page={page}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    currentSearch: state[REDUCER_NAME].currentSearch,
    watchListId: state[REDUCER_NAME].watchListId,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchDataPressing: (
      currentAvgVolume,
      currentOrder,
      currentProportion,
      sortState,
    ) =>
      dispatch(
        fetchDataPressing(
          currentAvgVolume,
          currentOrder,
          currentProportion,
          sortState,
        ),
      ),
    cancelfetchDataPressing: () => dispatch(cancelfetchDataPressing()),
    subscribeRealtimeTickPressing: data =>
      dispatch(subscribeRealtimeTickPressing(data)),
    changeFilterLineOne: value => dispatch(changeFilterLineOne(value)),
    changeFilterLineTwo: value => dispatch(changeFilterLineTwo(value)),
    changeFilterLineThree: value => dispatch(changeFilterLineThree(value)),
    loadMorePressing: data => dispatch(loadMorePressing(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Pressing);
